import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import CellContainer from '../components/CellContainer.vue';
let AmCellContainer = class AmCellContainer extends Mixins(CellContainer) {
  constructor() {
    super(...arguments);
    this.parentType = '';
  }
  get isCol() {
    return this.parentType === 'AmColContainer';
  }
  get isRow() {
    return this.parentType === 'AmRowContainer';
  }
  get style() {
    var _this$$el, _this$$el2;
    let parent = this.$parent;
    while (parent) {
      let name = parent.compName;
      if (name === 'AmRowContainer' || name === 'AmColContainer') {
        this.parentType = name;
        break;
      }
      parent = parent.$parent;
    }
    let styleflexBasis = {
      flexGrow: 0,
      flexShrink: 0
    };
    let size = this.isRow ? (_this$$el = this.$el) === null || _this$$el === void 0 ? void 0 : _this$$el.clientWidth : (_this$$el2 = this.$el) === null || _this$$el2 === void 0 ? void 0 : _this$$el2.clientHeight;
    if (this.flexBasis === 'fixed') {
      styleflexBasis.flexBasis = `${size}px`;
    }
    if (this.width) {
      let width = typeof this.width === 'number' ? this.width + 'px' : this.width;
      styleflexBasis.flexBasis = width;
    }
    if (this.flexBasis === 'fixed') {
      return styleflexBasis;
    } else {
      return {};
    }
  }
};
AmCellContainer.componentName = 'AmCellContainer';
AmCellContainer = __decorate([Component({
  name: 'AmCellContainer'
})], AmCellContainer);
export default AmCellContainer;